module.exports = __webpack_public_path__ + "static/media/royalton.8de05dda.png";